 import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { map, catchError, take } from 'rxjs/operators';
import { Subscription, throwError , interval} from 'rxjs'; 
import { AuthService } from 'src/app/services/auth.service'; 
import { Router } from '@angular/router';

  
  @Component({
    selector: 'app-mfa-verify',
    templateUrl: './mfa-verify.component.html',
    styleUrls: ['./mfa-verify.component.scss']
  })
  export class MfaVerifyComponent implements OnInit {
    private http: HttpClient;
    rolesList!: {
      id: number,
      rol: string
    }[];
    private url = environment.API_URL;

    public countdown: number = 300; // 5 minutos en segundos
    public countdownSubscription: Subscription | null = null;
    public isResendDisabled: boolean = true;
    public countdownDisplay: string = '5:00'

    formUser : any = {
      email : "",
      pass : "",
      mfa_code : ""
    }
    constructor(
      @Inject(MAT_DIALOG_DATA) public data:any,
      private fb: FormBuilder,
      private userS: UsersService,
      private dialogRef: MatDialogRef<MfaVerifyComponent>,
      private matDialog: MatDialog,
      handler: HttpBackend,
      private authService: AuthService,
      private router: Router
    ) {
      this.http = new HttpClient(handler);
    }

    @ViewChild('codeInput') codeInput!: ElementRef;

    ngAfterViewInit() {
      setTimeout(() => {
        this.codeInput.nativeElement.focus();
      });
    }
  
    ngOnInit(): void {
      this.rolesList = environment.roles;

      this.createFormUser();
      this.startCountdown();
      
    }

    createFormUser() {
    this.formUser.email =  this.data.email;
    this.formUser.pass =  this.data.pass;
      console.log(this.formUser, this.data);
    }

    getNotif(){

    }

    ruSure() {

       this.sendLogin();
  
    }
  
    sendLogin() {
      Swal.fire({
        icon: 'info',
        title: 'Enviando...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

    this.authService.login(this.formUser).subscribe(
        (resp: any) => {
          this.router.navigateByUrl('admin/dashboard');
          Swal.close();
          this.dialogRef.close({ logged: true, resp });
        },
        (err: any) => {
          Swal.close();
          console.error(err);
          Swal.fire({
            icon: 'error',
            title: 'Error de verificación',
            text: err.error?.message || 'El código MFA no es válido o ha expirado.'
          });
        }
      );

    }

    resendCode() {
     Swal.fire({
        icon: 'info',
        title: 'Enviando...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

    this.authService.login(this.data).subscribe(
        (resp: any) => {
           Swal.fire({
            icon: 'success',
            title: 'Código enviado',
            text: 'El nuevo código de verificación fue enviado.'
          });
          this.dialogRef.close();
        },
        (err: any) => {
          Swal.close();
          console.error(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al enviar',
            text: 'El código MFA no pudo ser enviado.'
          });
        }
      );


    }

    resetForm() {
      //this.notifList = [];
    }

        ngOnDestroy(): void {
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }
    }

    startCountdown(): void {
        this.isResendDisabled = true;
        this.countdown = 300; 
        
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }

        this.countdownSubscription = interval(1000)
            .pipe(take(this.countdown))
            .subscribe({
                next: () => {
                    this.countdown--;
                    this.updateCountdownDisplay();
                },
                complete: () => {
                    this.isResendDisabled = false;
                    this.countdownDisplay = '';
                }
            });
    }

    updateCountdownDisplay(): void {
        const minutes = Math.floor(this.countdown / 60);
        const seconds = this.countdown % 60;
        this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }

  
  }
  